export class TrendingFacetsModel {
  constructor(
    public attribute: string,
    public operator: string,
    public value: string,
    public count: number
  ) {}
}
